// @flow
'use strict';

import { connect } from 'react-redux';

import Pagamentos from './pagamentos';

export default connect<*, *, *, *, *, *>()(Pagamentos);
